import "./styles.css";

export const PercentageBar = ({ progress = 50 }) => {
  // progress: 0 to 100
  return (
    <div className="progress-container">
      <div className="progress-bar">
        <div
          className="progress-circle"
          style={{
            left: `${progress > 10 ? `calc(${progress}% - 10px)` : "0px"}`,
          }} // offset half circle width
        ></div>
      </div>
    </div>
  );
};
